module.exports = __webpack_public_path__ + "1.5.0-unryo/img/apache.668a77b3.svg";